import React, { useCallback, useContext, useEffect, useState } from "react";
import { CKEditor } from "ckeditor4-react";
import { Container } from "components";
import Breadcrumb from "components/molecules/Breadcrumb";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import { getData } from "actions";
import { API_URL_email, baseurl } from "constants/api";
import { emailReducers } from "redux/emailSlice";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import axios from "axios";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { PulseLoader } from "react-spinners";

const Diagnostics = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [adminAccess, setAdminAccess] = useState(false);
  const { datauser } = useContext(AuthContext);
  const { getEmailResult } = useSelector((state) => state.email);
  const [refreshEditor, setRefreshEditor] = useState(false);
  const [loadingOutgoing, setLoadingOutgoing] = useState(false);
  const [loadingIncoming, setLoadingIncoming] = useState(false);

  const get = useCallback(
    async (params) => {
      getData(
        API_URL_email,
        params,
        { dispatch, redux: emailReducers },
        "GET_EMAIL"
      );
    },
    [dispatch]
  );

  const formik = useFormik({
    initialValues: {
      email: "",
      to: "",
      title: "",
      body: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Email is required"),
      to: Yup.string().required("to is required"),
      title: Yup.string().required("title is required"),
      body: Yup.string().required("body is required"),
    }),
    onSubmit: (values) => {
      setLoadingOutgoing(true);

      const formData = new FormData();
      formData.append("email", values.email);
      formData.append("to", values.to);
      formData.append("title", values.title);
      formData.append("body", values.body);

      axios({
        headers: {
          Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
        },
        data: formData,
        method: "POST",
        url: baseurl + "/master/email/diagnosticoutgoingemail",
      })
        .then((response) => {
          formik.resetForm();
          setRefreshEditor(!refreshEditor);
          formik.setFieldValue("body", "");
          toast.success(response.data.message, {
            position: "top-center",
            autoClose: true,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setLoadingOutgoing(false);
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data && error.response.status !== 500) {
            // Jika respons mengandung data objek, tampilkan sebagai daftar
            Swal.fire({
              icon: "error",
              title: "Oops...",
              customClass: {
                container: "z-[99999]",
              },
              html: `
              <div>
                <ul>
                  ${(() => {
                    const entries = Object.entries(error.response.data);
                    return entries
                      .map(([key, value], index) => {
                        if (entries.length === 1) {
                          return `<li>${value}</li>`;
                        } else {
                          return `<li><strong>${key}</strong>: ${value}</li>`;
                        }
                      })
                      .join("");
                  })()}
                </ul>
              </div>
            `,
            });
          } else {
            // Jika respons tidak mengandung data objek, tampilkan pesan error langsung
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          }
          setLoadingOutgoing(false);
        });
    },
  });

  const fetchIncomingEmail = () => {
    setLoadingIncoming(true);
    axios({
      headers: {
        Authorization: `Bearer ${localStorage.getItem("sseccaxds")}`,
      },
      method: "GET",
      url: baseurl + "/master/email/diagnosticincomingemail",
    })
      .then((response) => {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: true,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoadingIncoming(false);
        setTimeout(() => {}, 10000);
      })
      .catch((error) => {
        console.log(error);
        if (error.response.data && error.response.status !== 500) {
          // Jika respons mengandung data objek, tampilkan sebagai daftar
          Swal.fire({
            icon: "error",
            title: "Oops...",
            customClass: {
              container: "z-[99999]",
            },
            html: `
            <div>
              <ul>
                ${(() => {
                  const entries = Object.entries(error.response.data);
                  return entries
                    .map(([key, value], index) => {
                      if (entries.length === 1) {
                        return `<li>${value}</li>`;
                      } else {
                        return `<li><strong>${key}</strong>: ${value}</li>`;
                      }
                    })
                    .join("");
                })()}
              </ul>
            </div>
          `,
          });
        } else {
          // Jika respons tidak mengandung data objek, tampilkan pesan error langsung
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        }
        setLoadingIncoming(false);
      });
  };

  const fetchData = useCallback(() => {
    const params = `?limit=99999999`;
    get(params);
  }, [get]);

  const toolbarConfig = {
    extraPlugins: "font,colorbutton,colordialog",
    removePlugins: "about,image",
    skin: "moono",
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (datauser !== "") {
      const permissionViewMenuAdmin = datauser.group_permissions.includes(
        "access_menu_admin"
      );
      if (permissionViewMenuAdmin) {
        setAdminAccess(true);
      } else {
        navigate("/dashboard/agent");
      }
    }
  }, [datauser]);

  if (!adminAccess) {
    return null;
  }

  return (
    <Container>
      <Breadcrumb
        title={"Email diagnostic"}
        excludedPaths={["email", "administrator"]}
        group={"Superadmin"}
      />
      <div className="bg-neutral dark:bg-neutral-800 rounded overflow-hidden shadow">
        <Tabs className="py-4 px-2">
          <TabList>
            <Tab>Outgoing email</Tab>
            <Tab>Incoming email</Tab>
          </TabList>

          <TabPanel>
            <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
              Send a mail to check outgoing email settings
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="h-auto w-auto px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
                <div className="mt-4 grid grid-cols-4 gap-4">
                  <div>
                    <label className="font-semibold">
                      From <span className="text-red-500">*</span> :
                    </label>
                  </div>

                  <div className="col-span-3">
                    <select
                      id="email"
                      name="email"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      className="block w-full md:w-1/2 lg:w-1/2 rounded-md border border-gray-500 bg-white py-2 px-2 text-gray-900 shadow-sm focus:ring-1 focus:ring-inset focus:ring-blue-400 sm:text-sm sm:leading-6"
                    >
                      <option value={""}>Select</option>
                      {getEmailResult.results &&
                        getEmailResult.results.map((item, index) => (
                          <option key={index} value={item.email_address}>
                            {item.email_address}
                          </option>
                        ))}
                    </select>
                    {formik.touched.email && formik.errors.email && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.email}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="font-semibold">
                      To <span className="text-red-500">*</span> :
                    </label>
                  </div>

                  <div className="col-span-3">
                    <input
                      type="email"
                      name="to"
                      id="to"
                      value={formik.values.to}
                      onChange={formik.handleChange}
                      className="block w-full md:w-1/2 lg:w-1/2 rounded-md border border-gray-500 bg-white py-1.5 px-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-blue-400 sm:text-sm sm:leading-6"
                    />
                    {formik.touched.to && formik.errors.to && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.to}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="font-semibold">
                      Subjek <span className="text-red-500">*</span> :
                    </label>
                  </div>

                  <div className="col-span-3">
                    <input
                      type="text"
                      name="title"
                      id="title"
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      className="block w-full md:w-1/2 lg:w-1/2 rounded-md border border-gray-500 bg-white py-1.5 px-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-1 focus:ring-blue-400 sm:text-sm sm:leading-6"
                    />
                    {formik.touched.title && formik.errors.title && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.title}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="font-semibold">
                      Pesan <span className="text-red-500">*</span> :
                    </label>
                  </div>

                  <div className="col-span-3 mb-4">
                    <CKEditor
                      key={refreshEditor}
                      config={toolbarConfig}
                      type="classic"
                      initData={formik.values.body}
                      onChange={(e) =>
                        formik.setFieldValue("body", e.editor.getData())
                      }
                    />
                    {formik.touched.body && formik.errors.body && (
                      <div className="text-red-500 dark:text-red-300 text-xs">
                        {formik.errors.body}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
                <button
                  type="submit"
                  disabled={loadingOutgoing}
                  className="flex w-16 items-center justify-center p-1 rounded shadow-sm border text-white bg-sky-800 hover:bg-sky-700"
                >
                  {loadingOutgoing ? (
                    <PulseLoader color="rgb(255 255 255)" size={14} />
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>
          </TabPanel>
          <TabPanel>
            <div className="h-12 w-full grid items-center px-4 bg-neutral-100 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600 text-xs md:text-base">
              Fetch Email Incoming
            </div>
            <div className="h-auto w-auto mb-10 px-4 bg-neutral dark:bg-neutral-800 border-b border-neutral-200 dark:border-neutral-600 object-left">
              <p className="text-xl font-bold">To test email fetching,</p>
              <p>
                If you receive a green alert, it means that the email settings
                are good and working
              </p>
              <p>
                If you receive a red alert, it means that the email settings are
                not working.
              </p>
            </div>
            <div className="h-12 w-full grid items-center px-4 bg-neutral-50 dark:bg-neutral-700 border-b border-neutral-200 dark:border-neutral-600">
              <button
                onClick={fetchIncomingEmail}
                disabled={loadingIncoming}
                className="flex w-16 items-center justify-center p-1 rounded shadow-sm border text-white bg-sky-800 hover:bg-sky-700"
              >
                {loadingIncoming ? (
                  <PulseLoader color="rgb(255 255 255)" size={14} />
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </TabPanel>
        </Tabs>
      </div>
    </Container>
  );
};

export default Diagnostics;
